import React from "react";
import AddContentPage from "../catalogue/AddContentPage";
import { createPodcastGeneralContent } from "../../../store/actions/uploadMediaAction";

const AddPodcast = () => (
  <AddContentPage
    title="Add Podcast"
    genreType="podcast"
    extraPayload={{ category: "podcast" }}
    createAction={createPodcastGeneralContent}
    savedKey="savedPodcast"
    editPath={(id) => `/dashboard/update-podcast/${id}`}
    missingKey="Please Fill Podcast Info!"
    successKey="Podcast Info Submitted Successfully!"
    cancelPath="/dashboard/podcast-list"
  />
);

export default React.memo(AddPodcast);
